import React from 'react';
import { translate } from 'react-i18next';

// Components & Constants
import CustomModal from 'components/CustomModal';
import { generateStatusList } from '../../services';

// Images
import Error from 'src/assets/images/for-pdf/crossMark-in-circle-red.svg';
import Success from 'src/assets/images/for-pdf/checkMark-in-circle-green.svg';

// Styles
import * as modalStyles from 'components/CustomModal/styles';

import ActiveIndicator from 'components/ActiveIndicator';
import ContentWrapper from './styles';

function parseImage(type) {
  if (type) {
    switch (type) {
      case generateStatusList[0]:
        return <img src={Error} alt="error"/>;
      case generateStatusList[1]:
        return <ActiveIndicator />;
      case generateStatusList[2]:
        return <img src={Success} alt="success"/>;
      default:
        return <img src={Error} alt="error"/>;
    }
  }
  return <img src={Error} alt="error"/>;
}

export default translate()(props => {
  const { isOpen, i18n, status, closeModal, onClickSavePDF, onTryAgainGeneratePDF } = props;

  const parseText = () => {
    if (status && typeof status === 'string') {
      switch (status) {
        case generateStatusList[0]:
          return (
            <span>
              {i18n.t('export_pdf_modal_error_msg')}{' '}
              <span className="try-again" onClick={onTryAgainGeneratePDF}>
                {i18n.t('try_again')}
              </span>
            </span>
          );
        case generateStatusList[1]:
          return <span>{i18n.t('export_pdf_modal_in_progress_msg')}</span>;
        case generateStatusList[2]:
          return <span>{i18n.t('export_pdf_modal_success_msg')}</span>;
        default:
          return null;
      }
    }
    return null;
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={{ content: { maxWidth: '30em', padding: 0 } }}
    >
      <modalStyles.CommonModalWrapper>
        {/* ──── Header ────────────────────────────────────────────────────────────────────── */}
        <modalStyles.ModalBlockSection className="header-wrapper">
          <modalStyles.ModalCloseIcon className="close-icon" onClick={closeModal} />
          <modalStyles.ModalTitle>{i18n.t('export_pdf_modal_caption')}</modalStyles.ModalTitle>
        </modalStyles.ModalBlockSection>

        {/* ──── Content ──────────────────────────────────────────────────────────────────── */}
        <modalStyles.ModalBlockSection>
          <ContentWrapper>
            <div>{parseImage(status)}</div>
            <div>{parseText()}</div>
          </ContentWrapper>
        </modalStyles.ModalBlockSection>

        {/* ──── Footer ───────────────────────────────────────────────────────────────────── */}

        <modalStyles.ModalFooter className="footer" topBorder>
          <modalStyles.ModalCancel onClick={closeModal}>{i18n.t('cancel')}</modalStyles.ModalCancel>

          <modalStyles.ModalFooterBtn
            style={{ minWidth: '140px' }}
            disabled={status !== generateStatusList[2]}
            onClick={onClickSavePDF}
          >
            {i18n.t('export_pdf_modal_save_btn')}
          </modalStyles.ModalFooterBtn>
        </modalStyles.ModalFooter>
      </modalStyles.CommonModalWrapper>
    </CustomModal>
  );
});
